import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import { GradientTypography } from '../gradients/GradientTypography';
import { Review } from 'functions/src/types/firestore/Game/Review';
import { useTheme } from '@mui/material/styles';
import { GradientIcon } from '../gradients/GradientIcon';

export type ReviewHeaderProps = Pick<Review<Date>, 'author' | 'recommended'>;

export function ReviewHeader({ author, recommended }: ReviewHeaderProps) {
  const { username, hoursPlayed } = author;
  const theme = useTheme();
  const getHoursString = (hoursPlayed: number) =>
    hoursPlayed <= 0
      ? ''
      : hoursPlayed === 1
      ? `${hoursPlayed} hour played`
      : `${hoursPlayed} hours played`;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <GradientTypography
          variant="subtitle1"
          gradientColor="primary.vertical"
        >
          @{username}
        </GradientTypography>
        {hoursPlayed && (
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 400,
              marginLeft: '2px',
              color: '#738399',
            }}
          >
            &nbsp;|&nbsp;{getHoursString(hoursPlayed).toUpperCase()}
          </Typography>
        )}
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <>
          <Typography
            sx={{
              background: recommended
                ? theme.palette.success.vertical
                : theme.palette.error.vertical,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              marginRight: '10px',
              textTransform: 'uppercase',
            }}
            variant="subtitle1"
          >
            {recommended ? 'Recommended' : 'Not Recommended'}
          </Typography>
          <GradientIcon
            gradientColor={
              recommended ? 'secondary.horizontal' : 'error.horizontal'
            }
            IconComponent={recommended ? ThumbUpIcon : ThumbDownIcon}
          />
        </>
      </Box>
    </Box>
  );
}
